import { getUserInfoReady } from '~/store/user-info'
import { api } from './api'

/**
 * The coin/gem balances the reward reveal's pills show. The backend splits
 * them across `GET /users/:id/coin` and `GET /users/:id/gem`; this merges
 * them into the one shape the pills consume.
 */
export interface UserCurrency {
  coin: number
  gem: number
}

export async function fetchUserCurrency(userId: number): Promise<UserCurrency> {
  const [{ coin }, { gem }] = await Promise.all([
    api.service.get(`user/users/${userId}/coin`).json<{ coin: number }>(),
    api.service.get(`user/users/${userId}/gem`).json<{ gem: number }>(),
  ])
  return { coin, gem }
}

/** Query option factories for `@tanstack/solid-query`. */
export const userQueries = {
  currency: () => ({
    queryKey: ['user', 'currency'] as const,
    queryFn: async () => {
      const { user_id } = await getUserInfoReady()
      return fetchUserCurrency(user_id)
    },
    // The cached balance is a pre-claim snapshot: the claim/redeem mutations
    // warm it (ensureQueryData) before the delivery credits it server-side,
    // and the reveal applies the delta locally on close. Never refetch — a
    // fetch after a delivery returns the already-credited balance, and the
    // local credit on top would double-count.
    staleTime: Infinity,
  }),
}
